import React, { useEffect } from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { setPageMeta } from "../seo/setPageMeta";
import { RECOVERY_JOURNEY_STEPS } from "../data/recoveryJourney";

export default function RecoveryJourneyStep() {
  const { step } = useParams();
  const index = parseInt(step, 10) - 1;
  const current = RECOVERY_JOURNEY_STEPS[index];

  useEffect(() => {
    if (!current) return;
    setPageMeta({
      title: `Step ${index + 1}: ${current.title} | Aletheia: Recovery Journey`,
      description: current.lesson.principle,
      canonical: `https://www.crindependenceky.com/recovery-journey/${index + 1}`,
    });
  }, [current, index]);

  if (!current) return <Navigate to="/recovery-journey" replace />;

  const { lesson } = current;
  const prev = index > 0 ? index : null;
  const next = index < RECOVERY_JOURNEY_STEPS.length - 1 ? index + 2 : null;

  return (
    <section className="journey-article">
      <h2 className="page-title">
        Step {index + 1}: {current.title}
      </h2>
      <span className="journey-word">This week's word: {lesson.word}</span>
      <p className="journey-reading">{current.reading}</p>

      <div className="journey-frame">
        <p className="journey-frame-label">PRINCIPLE</p>
        <p className="journey-frame-text">{lesson.principle}</p>
        <p className="journey-frame-label">STEP</p>
        <p className="journey-frame-text">{lesson.step}</p>
      </div>

      <h3 className="journey-section-head">Introduction</h3>
      <p className="journey-body">{lesson.intro}</p>

      {lesson.subsections.map((s) => (
        <React.Fragment key={s.heading}>
          <h3 className="journey-section-head">{s.heading}</h3>
          <p className="journey-body">{s.text}</p>
        </React.Fragment>
      ))}

      <h3 className="journey-section-head">What Is {lesson.word}?</h3>
      <p className="journey-body">{lesson.whatIs.intro}</p>
      <div className="journey-quote-box">
        {lesson.whatIs.selftalk.map((line) => (
          <p key={line} className="journey-quote-text">{line}</p>
        ))}
      </div>
      <p className="journey-body">{lesson.whatIs.closing}</p>

      <h3 className="journey-section-head">This Week's Acrostic</h3>
      {lesson.acrostic.map((item) => (
        <div key={item.heading} className="journey-acrostic-row">
          <div className="journey-acrostic-letter">{item.letter}</div>
          <div>
            <p className="journey-acrostic-heading">{item.heading}</p>
            <p className="journey-acrostic-text">{item.text}</p>
            <p className="journey-acrostic-cite">{item.cite}</p>
          </div>
        </div>
      ))}

      <h3 className="journey-section-head">Talk It Over</h3>
      <div className="journey-discussion">
        {lesson.discussion.map((q, i) => (
          <div key={q} className="journey-discussion-row">
            <span className="journey-discussion-num">{i + 1}.</span>
            <span>{q}</span>
          </div>
        ))}
      </div>

      <h3 className="journey-section-head">Wrap-Up</h3>
      <p className="journey-body">{lesson.wrapup}</p>
      <p className="journey-closing">{lesson.closing}</p>

      <div className="journey-nav">
        {prev ? (
          <Link className="btn btn-secondary" to={`/recovery-journey/${prev}`}>
            &larr; Previous Step
          </Link>
        ) : <span />}
        {next ? (
          <Link className="btn btn-secondary" to={`/recovery-journey/${next}`}>
            Next Step &rarr;
          </Link>
        ) : (
          <Link className="btn btn-secondary" to="/recovery-journey">
            Back to All Steps
          </Link>
        )}
      </div>
    </section>
  );
}
